import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import {
  Card,
  CardContent,
  Typography,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Radio,
  Select,
  InputLabel,
  MenuItem,
  TextField,
} from '@material-ui/core';
import { isEmpty, get, isNull } from 'lodash';
import { CheckCircle } from '@material-ui/icons';
import styled from 'styled-components';
import messages from 'containers/OpeningClaimPageManager/messages';
import { translate } from 'containers/services/translate';
import { CHOICE } from 'containers/PreOpeningPage/constants';
import { Config } from 'containers/AppContainer/typings';

const Container = styled.div`
  &&.container {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
  }
  .title {
    text-align: left;
    text-transform: inherit;
    font-size: 24px;
    letter-spacing: 0;
    margin-left: 10px;
    margin-bottom: 30px;
    color: #2b2727;
    display: inline;
    font-weight: 500;
    font-family: Roboto;
  }
  .MuiPaper-root {
    box-shadow: 0px 1px 3px #0000001f;
  }
  .subContainer {
    display: flex;
    justify-content: space-around;
    margin-top: 25px;
  }
  .smallSubContainer {
    display: flex;
    margin-top: 25px;
  }
  .input {
    width: 23%;
    margin-bottom: 33px;
  }
  .input-3 {
    width: 32%;
    margin-bottom: 33px;
  }
  .input-4 {
    width: 32%;
    margin-left: 30px;
    margin-bottom: 33px;
  }
  .checkdiv {
    align-items: center;
    display: flex;
    margin-left: 10px;
  }
  .text {
    text-align: left;
    font-size: 15px;
    color: #374065;
    margin-right: 17px;
    font-weight: Bold;
    font-family: Roboto;
  }
  .hideContent {
    visibility: hidden;
  }
  .label-input {
    font-size: 13px;
  }
  .MuiFormLabel-root {
    font-size: 13px;
  }
  .MuiInputLabel-shrink {
    color: #00000061;
  }
  .MuiFormLabel-root.Mui-focused {
    color: rgba(9, 122, 194, 1);
  }
  .error {
    margin-top: -5px;
    color: red;
    text-align: center;
  }
  .errorSelect {
    margin-top: 9px;
    color: red;
  }
`;
export interface CicaFormProps {
  intl: IntlShape;
  setDecision: Function;
  decision: string;
  reason: string;
  setReason: Function;
  listings: any;
  setOtherReason: Function;
  otherReason: string;
  nature: string;
}

const CicaForm: React.FC<CicaFormProps> = (props): JSX.Element => {
  const handleChange = (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
  ) => {
    props.setDecision(event.target.value);
    props.setReason(null);
    props.setOtherReason(null);
  };
  const handleChangeReason = (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
  ) => {
    props.setReason(event.target.value);
  };
  const handleChangeOtherReason = (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
  ) => {
    props.setOtherReason(event.target.value);
  };

  return (
    <Container className="container">
      <Card>
        <CardContent>
          <Typography className="title">
            {translate({ ...messages.changeNatureClaim }, props)}
          </Typography>
          <div className="checkdiv">
            <Typography className="text">
              {translate({ ...messages.changeNatureClaimQuestion }, props)}
            </Typography>

            <FormControl>
              <RadioGroup row onChange={handleChange} value={props.decision}>
                <FormControlLabel
                  control={
                    <Radio
                      color="primary"
                      value={CHOICE.YES}
                      checkedIcon={<CheckCircle />}
                    />
                  }
                  label={translate({ ...messages.yes }, props)}
                />
                <FormControlLabel
                  control={
                    <Radio
                      color="primary"
                      value={CHOICE.NO}
                      checkedIcon={<CheckCircle />}
                    />
                  }
                  label={translate({ ...messages.no }, props)}
                />
              </RadioGroup>
            </FormControl>
          </div>
          <div className="checkdiv">
            {props.decision === CHOICE.NO && (
              <>
                <FormControl className="input">
                  <InputLabel id="idd-label-id">
                    {translate(messages.reason, props)}
                  </InputLabel>
                  <Select
                    labelId="idd-label-id"
                    onChange={handleChangeReason}
                    name={'reason'}
                    value={props.reason}
                    labelWidth={60}
                  >
                    {!isEmpty(
                      get(props.listings, 'claimConvertingRejectionReason', []),
                    ) &&
                      get(props.listings, 'claimConvertingRejectionReason', [])
                        .filter(
                          (el: Config) =>
                            el.type === props.nature?.toUpperCase() ||
                            isNull(el.type),
                        )
                        .map((el: Config) => (
                          <MenuItem key={el.id} value={el.id}>
                            {el.title}
                          </MenuItem>
                        ))}
                  </Select>
                </FormControl>
                {props.reason ===
                  get(
                    get(
                      props.listings,
                      'claimConvertingRejectionReason',
                      [],
                    ).find((el: Config) => el.title === 'Autre'),
                    'id',
                  ) && (
                  <TextField
                    onChange={handleChangeOtherReason}
                    name={'otherReason'}
                    value={props.otherReason}
                    label={translate({ ...messages.reason }, props)}
                    className="input"
                    multiline
                    fullWidth
                    style={{ marginLeft: 10 }}
                  />
                )}
              </>
            )}
          </div>
        </CardContent>
      </Card>
    </Container>
  );
};
export default injectIntl(CicaForm);
